// extracted by mini-css-extract-plugin
export default {"icon":"Step-module__icon__MWWhE","incomplete":"Step-module__incomplete__3Adf8"};